export default __webpack_public_path__ + "static/media/filmify.bcb777df.JPG";